<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25.811 25.811"
        style="fill: currentColor"
    >
        <g id="zoom-out" transform="translate(-3.75 -3.75)">
            <path
                id="Tracé_110"
                data-name="Tracé 110"
                d="M25.834,15.167A10.667,10.667,0,1,1,15.167,4.5,10.667,10.667,0,0,1,25.834,15.167Z"
                transform="translate(0 0)"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
            />
            <path
                id="Tracé_111"
                data-name="Tracé 111"
                d="M30.775,30.775l-5.8-5.8"
                transform="translate(-2.275 -2.275)"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
            />
            <path
                id="Tracé_113"
                data-name="Tracé 113"
                d="M12,16.5h8.252"
                transform="translate(-0.959 -1.335)"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
            />
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-zoom-out",
});
</script>
